export const scheduleMicrotask = (window: Window, fn: () => void): void => {
    if (typeof queueMicrotask !== "function") {
        fn();
        return;
    }

    window.queueMicrotask(fn);
};
